import { render, staticRenderFns } from "./PackageItem.vue?vue&type=template&id=0523b8ad&scoped=true"
import script from "./PackageItem.vue?vue&type=script&lang=js"
export * from "./PackageItem.vue?vue&type=script&lang=js"
import style0 from "./PackageItem.vue?vue&type=style&index=0&id=0523b8ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0523b8ad",
  null
  
)

export default component.exports